import PageTabHeader, { PageTabHeaderProps } from "./PageBody/PageTabHeader";

interface Props extends PageTabHeaderProps {}

export default function ViewContentBlockHeader({ children, ...otherProps }: Props) {
  return <PageTabHeader {...otherProps}>{children}</PageTabHeader>;
}
